// extracted by mini-css-extract-plugin
module.exports = {"r-mobile":"strategySelector_r-mobile__pp51W","r-not-mobile":"strategySelector_r-not-mobile__xwfw4","container":"strategySelector_container__jpGI7"};